import { Link } from "react-router-dom";
import TextField from "@/component/widgets/text-field";
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { useQueryParams } from "@/hooks/useQueryParams";
import { userRepo } from "@/repo/user-repo";
import { AppContextType, WonmovContext } from "@/context/app-context";
import { DeviceData } from "@/entry/server/user";
import PhoneIcon from "@public/img/phone-device.svg";
import TvIcon from "@public/img/tv-device.svg";
import WebIcon from "@public/img/web-device.svg";
import DesktopIcon from "@public/img/desktop-device.svg";
import TrashIcon from "@public/img/trash.svg";
import { getFormValue } from "@/utils/get-form-value";

function AuthPage() {
  const queryParams = useQueryParams();
  const next = queryParams.next ? queryParams.next : "/";
  const { setNotification, setIsLoggedIn, setUser, setVipData } = useContext<AppContextType>(WonmovContext);
  const [page, setPage] = useState<"login" | "register">("login");
  const [devices, setDevices] = useState<DeviceData[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  const handlePageChange = (page: "login" | "register") => {
    setPage(page);
  }
  const login = async (username: string, password: string) => {
    if (isLoading) return;

    setIsLoading(true);
    const res = await userRepo.login(username, password);
    if (!res.status) {
      if (res.message === "device_limit_exceeded") {
        const devicesRes = await userRepo.getDevices();
        if (!devicesRes.status) {
          setNotification({ type: "danger", message: devicesRes.message });
          setIsLoading(false);
          return;
        }
        setUsername(username);
        setPassword(password);
        setDevices(devicesRes.data ? devicesRes.data : []);
        setIsLoading(false);
        return;
      } else {
        setNotification({ type: "danger", message: res.message });
        setIsLoading(false);
        return;
      }
    }
    const res2 = await userRepo.getMe()
    if (!res2.status) {
      setNotification({ type: "danger", message: res2.message });
      setIsLoading(false);
      return;
    }

    setIsLoggedIn(true);
    setUser(res.data && res.data.user ? res.data.user : null);
    setVipData(res2.data && res2.data.vip ? res2.data.vip : null);
    history.replace(next ? next : "/");
    setNotification({ type: "success", message: "ورود با موفقیت انجام شد" });
    setIsLoading(false);
  }
  const register = async (username: string, name: string, email: string, password: string, confirmPassword: string) => {
    if (isLoading) return;

    setIsLoading(true);
    const res = await userRepo.register(username, name, email, password, confirmPassword);
    if (!res.status) {
      setNotification({ type: "danger", message: res.message });
      setIsLoading(false);
      return;
    }
    setIsLoggedIn(true);
    setUser(res.data && res.data.user ? res.data.user : null);
    setVipData({
      is_vip: false,
      days_left: 0,
      end_date: "",
      start_date: "",
    });
    history.replace(next ? next : "/");
    setNotification({ type: "success", message: "ثبت نام با موفقیت انجام شد" });
    setIsLoading(false);
  }

  const handleDeleteDevice = async (index: number) => {
    if (isLoading) return;

    let deviceToken = "all";
    if (index >= 0) {
      deviceToken = devices[index].device_token;
    }
    setIsLoading(true);
    setDevices([]);
    const res = await userRepo.deleteDevice(deviceToken);
    setIsLoading(false);
    if (!res.status) {
      setNotification({ type: "danger", message: res.message });
      return;
    }
    login(username, password);
  }

  return (
    <>
      <div className="auth-card">
        <span className="auth-card__logo">WONMOV</span>
        <div className="auth-tabs">
          <button
            type="button"
            className={`auth-tabs__btn ${page === "login" ? "is-active" : "is-inactive"}`}
            onClick={() => handlePageChange("login")}
          >
            ورود
          </button>
          <button
            type="button"
            className={`auth-tabs__btn ${page === "register" ? "is-active" : "is-inactive"}`}
            onClick={() => handlePageChange("register")}
          >
            ثبت نام
          </button>
        </div>

        {page === "login" ? <LoginForm handleSubmit={login} isLoading={isLoading} /> : <RegisterForm handleSubmit={register} isLoading={isLoading} />}
      </div>
      {devices.length > 0 && <DeviceList devices={devices} onDelete={handleDeleteDevice} />}
    </>
  );
}

function LoginForm({ handleSubmit, isLoading }: { handleSubmit: (username: string, password: string) => void, isLoading: boolean }) {

  return (
    <>
      <form
        className="auth-form"
        onSubmit={function (e) {
          e.preventDefault();
          var form = e.currentTarget;
          handleSubmit(
            getFormValue(form, "username"),
            getFormValue(form, "password")
          );
        }}
      >
        <div className="auth-field">
          <TextField
            name="username"
            type="text"
            placeholder="نام کاربری"
            autoComplete="username"
            required
          />
        </div>

        <div className="auth-field">
          <TextField
            name="password"
            type="password"
            placeholder="رمز عبور"
            autoComplete="current-password"
            required
          />
        </div>

        <button type="submit" className="auth-submit">
          {isLoading ? <div className="loader"></div> : "ورود به حساب"}
        </button>
      </form>

      <Link to="/auth/forgot-password" className="auth-link">
        رمز عبور را فراموش کرده‌ام
      </Link>
    </>
  )
}

function RegisterForm({ handleSubmit, isLoading }: { handleSubmit: (username: string, name: string, email: string, password: string, confirmPassword: string) => void, isLoading: boolean }) {
  return (
    <>
      <form
        className="auth-form"
        onSubmit={function (e) {
          e.preventDefault();
          var form = e.currentTarget;
          handleSubmit(
            getFormValue(form, "username"),
            getFormValue(form, "name"),
            getFormValue(form, "email"),
            getFormValue(form, "password"),
            getFormValue(form, "confirm-password")
          );
        }}
      >
        <div className="auth-field">
          <TextField
            name="username"
            type="text"
            placeholder="نام کاربری"
            autoComplete="username"
            required
          />
        </div>

        <div className="auth-field">
          <TextField
            name="email"
            type="email"
            placeholder="ایمیل"
            autoComplete="email"
            required
          />
        </div>

        <div className="auth-field">
          <TextField
            name="name"
            type="text"
            placeholder="نام"
            autoComplete="name"
            required
          />
        </div>

        <div className="auth-field">
          <TextField
            name="password"
            type="password"
            placeholder="رمز عبور"
            autoComplete="new-password"
            required
          />
        </div>

        <div className="auth-field">
          <TextField
            name="confirm-password"
            type="password"
            placeholder="تکرار رمز عبور"
            autoComplete="new-password"
            required
          />
        </div>

        <button type="submit" className="auth-submit">
          {isLoading ? <div className="loader"></div> : "ثبت نام"}
        </button>
      </form>
    </>
  )
}

function DeviceList({ devices, onDelete }: { devices: DeviceData[], onDelete: (index: number) => void }) {
  const getDeviceIcon = (deviceType: string) => {
    switch (deviceType) {
      case "android":
      case "ios":
        return PhoneIcon;
      case "tv":
        return TvIcon;
      case "web":
        return WebIcon;
      case "windows":
      case "linux":
      case "macos":
        return DesktopIcon;
      default:
        return WebIcon;
    }
  }
  return (
    <div className="auth-device-overlay">
      <div className="auth-device-overlay__wrap">
        <div className="auth-device-overlay__cell">
          <div className="auth-device-dialog">
            <p className="auth-device-dialog__title">دستگاه های فعال حساب</p>
            <p className="auth-device-dialog__desc">
              دستگاه های فعال حساب شما از 5 عدد بشتر شده. برای ورود یکی از دستگاه های حساب باید حذف شود.
            </p>

            <div className="auth-device-list">
              {devices.map(function (device, index) {
                return (
                  <div key={index} className="auth-device-item">
                    <img
                      src={getDeviceIcon(device.device_type)}
                      alt={device.device_name}
                      className="auth-device-item__icon"
                    />
                    <span className="auth-device-item__name">{device.device_name}</span>
                    <button
                      type="button"
                      className="auth-device-item__delete"
                      onClick={function () {
                        onDelete(index);
                      }}
                    >
                      <img src={TrashIcon} alt="حذف" />
                    </button>
                  </div>
                );
              })}
            </div>

            <button
              type="button"
              className="auth-device-delete-all"
              onClick={function () {
                onDelete(-1);
              }}
            >
              حذف همه
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthPage;
